import { styled } from '@stitches/configed';
import { ReactNode } from 'react';
import DoubleCheckCircleIcon from '../Icons/DoubleCheckCircleIcon';
import NotFound404Icon from '../Icons/NotFound404Icon';
import SendMailSuccessIcon from '../Icons/SendMailSuccessIcon';
import WarningIcon from '../Icons/WarningIcon';

const Wrap = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%',
  height: '100%',
  svg: {
    fontSize: 88,
  },
});
const Title = styled('div', {
  marginTop: 24,
  fontWeight: 700,
  uTextSize: 'xl',
  marginBottom: 16,
});
const Message = styled('div', {
  marginBottom: 24,
  color: '$text2',
});
const IconWrapper = styled('div', {
  variants: {
    type: {
      404: {
        svg: {
          fontSize: 254,
        },
      },
      success: {
        svg: {
          fontSize: 88,
        },
      },
      warning: {
        svg: {
          fontSize: 88,
          color: '$warning',
        },
      },
      sendmailsuccess: {
        svg: {
          fontSize: 88,
        },
      },
    },
  },
});

type Props = {
  type: 'success' | 'warning' | '404' | 'sendmailsuccess';
  title?: string;
  message?: string | ReactNode;
  children?: ReactNode;
};
const Result = ({ type, title, message, children }: Props) => {
  let Icon;
  if (type === 'success') Icon = <DoubleCheckCircleIcon />;
  if (type === 'warning') Icon = <WarningIcon />;
  if (type === '404') Icon = <NotFound404Icon />;
  if (type === 'sendmailsuccess') Icon = <SendMailSuccessIcon />;
  return (
    <Wrap>
      <IconWrapper type={type}>{Icon}</IconWrapper>
      <Title>{title ? title : ''}</Title>
      <Message>{message ? message : ''}</Message>
      {children}
    </Wrap>
  );
};

export default Result;
